@if((admin || order.orderStatusTypeID === 'Complete') && dataSource.data.length > 0) {
<mat-card class="results-content card-margin">
    <div class="table-container">
        <table mat-table [dataSource]="dataSource" multiTemplateDataRows>
            <!-- Icon -->
            <ng-container matColumnDef="icon">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    @if(row.shareholderType === 'Business') {
                    <mat-icon class="icon-warning">warning</mat-icon>
                    }
                </td>
            </ng-container>
            <!-- Name -->
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.name' | transloco }}</th>
                <td mat-cell *matCellDef="let row">
                    {{ formatName(row) }}
                    @if (row.attestorParty; as attestor) {
                        <div class="text-faded">
                            {{attestor.firstName}}
                            @if (attestor.middleName) {
                            {{attestor.middleName}}
                            }
                            {{ attestor.lastName }}
                            @if (attestor.contactDetails?.email) {
                            ({{attestor.contactDetails?.email}})
                            }
                        </div>
                    }
                </td>
            </ng-container>

            <!-- Shareholder Type -->
            <ng-container matColumnDef="address">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.address' | transloco }}</th>
                <td mat-cell *matCellDef="let row" class="padded-cell">{{ formatAddress(row) }}</td>
            </ng-container>

            <!-- Business Country -->
            <ng-container matColumnDef="businessCountry">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.businessCountry' | transloco }}</th>
                <td mat-cell *matCellDef="let row">{{ row.businessCountry || '—' }}</td>
            </ng-container>

            <!-- Business Jurisdiction -->
            <ng-container matColumnDef="businessJurisdiction">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.businessJurisdiction' | transloco }}</th>
                <td mat-cell *matCellDef="let row">{{ getBusinessJurisdiction(row.businessJurisdiction) }}</td>
            </ng-container>

            <!-- Business Number -->
            <ng-container matColumnDef="businessNumber">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.businessNumberShort' | transloco }}</th>
                <td mat-cell *matCellDef="let row">{{ row.party.busNumber || '—' }}</td>
            </ng-container>

            <!-- Date of Birth -->
            <ng-container matColumnDef="dateOfBirth">
                <th mat-header-cell *matHeaderCellDef>{{ 'common.labels.dob' | transloco }}</th>
                <td mat-cell *matCellDef="let row">{{ (row.party.dateOfBirth | date: 'yyyy-MM-dd') ?? '—' }}</td>
            </ng-container>

            <!-- Date of Birth -->
            <ng-container matColumnDef="isValidated">
                <th mat-header-cell *matHeaderCellDef>{{ 'uboBeneficialOwnersReview.validated' | transloco }}</th>
                <td mat-cell *matCellDef="let row">{{ row.party.partyTypeID === 'IndividualShareholder' ? '—' : row.isValidated ? 'Yes' : 'No' }}</td>
            </ng-container>

            <!-- Level -->
            <ng-container matColumnDef="ownershipLevel">
                <th mat-header-cell *matHeaderCellDef class="mat-column-level">
                    {{ 'uboBeneficialOwnersReview.level' | transloco }}
                </th>
                <td mat-cell *matCellDef="let row" class="mat-column-level">
                    {{ row.ownershipLevel }}
                </td>
            </ng-container>

            <!-- Ownership % of Parent-->
            <ng-container matColumnDef="ownershipPercentageOfParent">
                <th mat-header-cell *matHeaderCellDef class="mat-column-percentage">
                    {{ 'uboBeneficialOwnersReview.ownershipOfParent' | transloco }}
                </th>
                <td mat-cell *matCellDef="let row" class="mat-column-percentage">
                    {{ row.ownershipPercentageOfParent }}%
                </td>
            </ng-container>

            <!-- Ownership % of Root-->
            <ng-container matColumnDef="ownershipPercentageOfRoot">
                <th mat-header-cell *matHeaderCellDef class="mat-column-percentage">
                    {{ 'uboBeneficialOwnersReview.ownershipOf' | transloco: { name: rootEntityName } }}
                </th>
                <td mat-cell *matCellDef="let row" class="mat-column-percentage">
                    {{ row.ownershipPercentageOfRoot }}%
                </td>
            </ng-container>

            <!-- Actions -->
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    @if(row.shareholderType === 'Business') {
                    <button color="primary" (click)="$event.stopPropagation()" mat-icon-button
                        [matMenuTriggerFor]="menu" [attr.aria-label]="'common.labels.actions' | transloco" data-testid="shareholder-action-dropdown">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                        @if(row.businessNumber && row.businessJurisdiction) {
                        <button mat-menu-item (click)="orderBusinessReport(row)" [attr.aria-label]="'uboBeneficialOwnersReview.orderBusinessReport' | transloco"
                            data-testid="action-dropdown-order-business-report-button">
                            <mat-icon color="primary">search_insights</mat-icon>
                            <span>{{ 'uboBeneficialOwnersReview.orderBusinessReport' | transloco }}</span>
                        </button>
                        }
                        <button mat-menu-item (click)="orderBusinessSearch(row)" [attr.aria-label]="'uboBeneficialOwnersReview.orderBusinessSearch' | transloco"
                            data-testid="action-dropdown-order-business-search-button">
                            <mat-icon color="primary">search</mat-icon>
                            <span>{{ 'uboBeneficialOwnersReview.orderBusinessSearch' | transloco }}</span>
                        </button>
                    </mat-menu>
                    }
                </td>
            </ng-container>

            <!-- Header & Rows -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
    </div>

    <!-- Else template -->
</mat-card>
} @else if(!admin && order.orderStatusTypeID === 'AwaitingExternalInformation') {
<mat-card class="flex-container margin-top-25">
    <div class="padding text-faded margin-top">{{ 'uboBeneficialOwnersReview.shareholdersWillPopulateOnceTheAttestation' | transloco }}</div>
</mat-card>
} @else if (hasDeclaredDoNotKnowAnyShareholders) {
<mat-card class="flex-container margin-top-25">
    <div class="padding text-faded margin-top">{{ 'uboBeneficialOwnersReview.attestorHasDeclaredThatTheyDo' | transloco }}</div>
</mat-card>
} @else if (hasDeclaredDoNotKnowMoreShareholders) {
<mat-card class="flex-container margin-top-25">
    <div class="padding text-faded margin-top">{{ 'uboBeneficialOwnersReview.attestorHasDeclaredThatTheyDo2' | transloco }}</div>
</mat-card>
}
